module.exports = __webpack_public_path__ + "img/chat_boot.03a147fc.gif";